module.exports = "/_next/static/images/favicon-c794038d95fc3cd7ba4298491462c0d7.png";